import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  FaFileInvoiceDollar,
  FaGavel,
  FaBuilding,
  FaHandHoldingUsd,
  FaGlobeAsia,
  FaRobot,
  FaArrowRight,
  FaTimes,
} from "react-icons/fa";

// แผงบริการเลื่อนเข้าจากขอบขวาตอนเข้าหน้าแรก (พื้นหลังจางน้อยๆ ยังเห็น hero)
// มี checkbox "ไม่ต้องแสดงอีกวันนี้" → เก็บวันที่ลง localStorage แล้วไม่เด้งอีกจนข้ามวัน
const STORAGE_KEY = "ttl_services_popup_hide_date";

// บริการเด่น 6 ตัว (id ตรงกับ services_page.items.* และลิงก์ /service#id)
const FEATURED = [
  { id: "tax_planning", Icon: FaFileInvoiceDollar },
  { id: "litigation", Icon: FaGavel },
  { id: "corporate", Icon: FaBuilding },
  { id: "debt", Icon: FaHandHoldingUsd },
  { id: "foreign_compliance", Icon: FaGlobeAsia },
  { id: "ai_solution", Icon: FaRobot },
];

function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

export default function ServicesPopup() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [dontShow, setDontShow] = useState(false);

  const dismiss = () => {
    if (dontShow) {
      try { localStorage.setItem(STORAGE_KEY, todayStr()); } catch (_) { /* private mode */ }
    }
    setOpen(false);
  };
  const goTo = (path) => { dismiss(); navigate(path); };

  // เปิดตอน mount — เว้นถ้าวันนี้กด "ไม่ต้องแสดงอีกวันนี้" ไปแล้ว
  useEffect(() => {
    let hideDate = null;
    try { hideDate = localStorage.getItem(STORAGE_KEY); } catch (_) { /* private mode */ }
    if (hideDate === todayStr()) return undefined;
    const tid = setTimeout(() => setOpen(true), 600);
    return () => clearTimeout(tid);
  }, []);

  // ปิดด้วย Esc ขณะเปิด — ไม่ล็อก scroll/ไม่บังพื้นหลัง ให้ใช้หน้าเว็บได้ปกติ
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") dismiss(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, dontShow]);

  if (!open) return null;

  return (
    <div className="svc-pop-host">
      <style>{`
        .svc-pop-host { position: fixed; inset: 0; z-index: 9999; pointer-events: none; display: flex; align-items: center; justify-content: flex-end; padding: 24px; box-sizing: border-box; }
        .svc-pop { pointer-events: auto; position: relative; width: 100%; max-width: 380px; max-height: 86vh; background: #fff; border-radius: 18px; box-shadow: 0 24px 70px rgba(0,0,0,0.30); border-left: 5px solid #D4AF37; display: flex; flex-direction: column; overflow: hidden; animation: svcSlide .38s cubic-bezier(.2,.85,.25,1); font-family: 'Prompt','Sarabun',sans-serif; }
        .svc-pop-close { position: absolute; top: 14px; right: 14px; width: 36px; height: 36px; border-radius: 50%; border: none; background: #f1f5f9; color: #475569; font-size: 15px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: .2s; z-index: 2; }
        .svc-pop-close:hover { background: #0b1220; color: #fff; }
        .svc-pop-head { flex-shrink: 0; text-align: center; padding: 30px 24px 14px; }
        .svc-pop-head h2 { margin: 0; font-size: 1.55rem; font-weight: 800; color: #0b1220; }
        .svc-pop-head h2::after { content: ""; display: block; width: 48px; height: 3px; background: #D4AF37; margin: 11px auto 0; border-radius: 2px; }
        .svc-pop-head p { margin: 12px auto 0; max-width: 320px; color: #64748b; font-size: .9rem; line-height: 1.55; }
        .svc-list { flex: 1; overflow-y: auto; padding: 6px 16px; }
        .svc-row { display: flex; align-items: center; gap: 13px; width: 100%; padding: 13px 10px; border: none; background: none; cursor: pointer; text-align: left; font-family: inherit; border-bottom: 1px solid #f1f5f9; border-radius: 10px; transition: .18s; }
        .svc-row:last-child { border-bottom: none; }
        .svc-row:hover { background: #f8fafc; }
        .svc-row-ic { width: 42px; height: 42px; border-radius: 11px; background: #0b1220; color: #D4AF37; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
        .svc-row-body { flex: 1; min-width: 0; }
        .svc-row-title { display: block; font-size: .98rem; font-weight: 800; color: #0b1220; line-height: 1.3; }
        .svc-row-desc { display: block; margin-top: 2px; font-size: .82rem; color: #64748b; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .svc-row-arrow { color: #D4AF37; font-size: 13px; flex-shrink: 0; opacity: .5; transition: .2s; }
        .svc-row:hover .svc-row-arrow { opacity: 1; transform: translateX(3px); }
        .svc-pop-foot { flex-shrink: 0; display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; padding: 14px 20px 18px; background: #fff; border-top: 1px solid #eef2f7; }
        .svc-pop-check { display: flex; align-items: center; gap: 9px; cursor: pointer; color: #64748b; font-size: .86rem; user-select: none; }
        .svc-pop-check input { width: 16px; height: 16px; accent-color: #D4AF37; cursor: pointer; }
        .svc-pop-cta { display: inline-flex; align-items: center; gap: 8px; background: #0b1220; color: #fff; border: none; border-radius: 50px; padding: 11px 22px; font-family: inherit; font-size: .92rem; font-weight: 800; cursor: pointer; transition: .25s; box-shadow: 0 10px 24px rgba(11,18,32,.2); }
        .svc-pop-cta:hover { background: #D4AF37; color: #0b1220; }
        @keyframes svcFade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes svcSlide { from { transform: translateX(100%); } to { transform: translateX(0); } }
        @media (max-width: 620px) {
          .svc-pop-host { justify-content: center; padding: 16px; }
          .svc-pop { max-width: 100%; max-height: 84vh; }
          .svc-pop-head { padding: 26px 18px 10px; }
          .svc-pop-head h2 { font-size: 1.4rem; }
          .svc-pop-foot { padding: 12px 16px 16px; justify-content: center; }
        }
      `}</style>

      <div className="svc-pop" role="dialog" aria-label={t("home.services_popup.title")}>
        <button className="svc-pop-close" onClick={dismiss} aria-label="close">
          <FaTimes />
        </button>

        <div className="svc-pop-head">
          <h2>{t("home.services_popup.title")}</h2>
          <p>{t("home.services_popup.subtitle")}</p>
        </div>

        <div className="svc-list">
          {FEATURED.map(({ id, Icon }) => (
            <button type="button" className="svc-row" key={id} onClick={() => goTo(`/service#${id}`)} aria-label={t(`services_page.items.${id}.title`)}>
              <span className="svc-row-ic"><Icon /></span>
              <span className="svc-row-body">
                <span className="svc-row-title">{t(`services_page.items.${id}.title`)}</span>
                <span className="svc-row-desc">{t(`services_page.items.${id}.intro`)}</span>
              </span>
              <FaArrowRight className="svc-row-arrow" />
            </button>
          ))}
        </div>

        <div className="svc-pop-foot">
          <label className="svc-pop-check">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
            />
            <span>{t("home.services_popup.hide_today")}</span>
          </label>
          <button className="svc-pop-cta" onClick={() => goTo("/service")}>
            {t("home.services_popup.view_all")} <FaArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
}
